import React, { FunctionComponent } from 'react';

import Flex, { justifyContentType } from '@components/layout/flex';
import Typography, { TypographyType } from '@components/basics/typography';
import QuestionMarkHelper from '@components/basics/question-mark-helper';
import styled, { useTheme } from 'styled-components';

interface TitleWithHelperProps {
  className?: string;
  id: string;
  title: React.ReactNode;
  titleDecoration?: React.ReactNode;
  helperText?: React.ReactNode;
  subtitle?: React.ReactNode;
  justifyContent?: justifyContentType;
  typographyType?: TypographyType;
  small?: boolean;
  titleWeight?: string;
  isGrey?: boolean;
}

const TitleWithHelper: FunctionComponent<TitleWithHelperProps> = ({
  className,
  id,
  title,
  titleDecoration,
  helperText,
  subtitle,
  justifyContent,
  typographyType,
  small,
  titleWeight,
  isGrey,
}) => {
  const theme = useTheme();
  return (
    <div className={className || ''}>
      <Flex
        justifyContent={justifyContent ? justifyContent : 'flex-start'}
        alignItems="center"
        gap={10}
      >
        <Flex justifyContent="flex-start" alignItems="center" gap={5}>
          <Typography
            type={
              small ? undefined : typographyType ? typographyType : 'big-title'
            }
            customFont={small ? undefined : 'semi-bold'}
            weight={titleWeight}
            color={isGrey ? theme.colors.tertiary : undefined}
          >
            {title}
          </Typography>
          {titleDecoration ? titleDecoration : null}
        </Flex>
        {helperText && (
          <QuestionMarkHelper id={id}>{helperText}</QuestionMarkHelper>
        )}
      </Flex>
      {subtitle && !isGrey && (
        <Typography className="subtitle" type="small">
          {subtitle}
        </Typography>
      )}
    </div>
  );
};

export default styled(TitleWithHelper)`
  position: relative;
  display: grid;
  grid-gap: ${(props) => (props.small ? '3px' : '5px')};

  .subtitle {
    color: ${({ theme }) => theme.colors.tertiary};
  }
`;
